import React from "react";
import { Bars } from "react-loader-spinner";
import { THEME } from "@/lib/theme";

const InnerContainerLoader = ({ offset = 12, fullscreen = false }) => {
  const isFullscreen = fullscreen;

  return (
    <div
      className={
        isFullscreen
          ? "fixed inset-0 z-50 flex items-center justify-center"
          : "relative flex w-full items-center justify-center"
      }
      style={
        isFullscreen
          ? undefined
          : { height: "calc(100vh - var(--dynamic-mt, 0px))" }
      }
    >
      <div className="flex items-center justify-center">
        <Bars
          height="36"
          width="36"
          color={THEME.primary}
          ariaLabel="bars-loading"
          wrapperStyle={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          wrapperClass=""
          visible={true}
        />
      </div>
      {!isFullscreen && (
        <style>
          {`
        @media (min-width: 768px) { /* Corresponds to Tailwind's 'md' breakpoint */
          :root {
            --dynamic-mt: ${offset}rem; /* 24 units for 'md' and above */
          }
        }
        @media (max-width: 767px) {
          :root {
            --dynamic-mt: ${offset / 2}rem; /* 12 units for below 'md' */
          }
        }
      `}
        </style>
      )}
    </div>
  );
};

export default InnerContainerLoader;
